import AuthLayout from './AuthLayout';
import { Box, Typography } from '@mui/material';
import VerifyPinComponent, { ValidateCodeInputs } from 'components/Common/VerifyPinComponent';
import { useState } from 'react';

const VerifyPinCode = () => {
    const [error, setError] = useState('');

    // const handlePaste = (e: React.ClipboardEvent) => {
    //     e.preventDefault();
    //     const pastedData = e.clipboardData.getData('Text').replace(/[^0-9]/g, '').substring(0, 6);
    //     pastedData.split('').forEach((char, i) => {
    //         setValue(`code${i + 1}` as keyof ValidateCodeInputs, char);
    //         const currentRef = focusRefs[i]?.current;
    //         if (currentRef) {
    //             currentRef.value = char;
    //             currentRef.dispatchEvent(new Event('input', { bubbles: true }));
    //             if (i < 5 && focusRefs[i + 1]?.current) {
    //                 focusRefs[i + 1].current?.focus();
    //             }

    //         }
    //     });
    // };
    const handleVerifyPinCode = async (data: ValidateCodeInputs) => {
        const code = Object.values(data).join('');
        if (code.length < 6) {
            setError('Please fill all the fields.');
        } else {
            setError('');
        }
    };

    return (
        <AuthLayout>
            <div className="Auth-form">
                <Box p={5}>
                    <Typography variant="h5">Account verification</Typography>
                    <br />
                    <Typography>
                        We have sent a verification code to the email used to create this account. Please provide that code in order to
                        validate this account.
                    </Typography>
                    <VerifyPinComponent validateCode={handleVerifyPinCode} error={error} setError={setError} />
                </Box>
            </div>
        </AuthLayout>
    );
};

export default VerifyPinCode;
